import { FlexProps } from '@mantine/core';
import styled from 'styled-components';
import type { EditableInfoContainerGridColumns } from './styled.types';

export const EDITABLE_INFO_LABEL_COLUMN_WIDTH = '264px';

export const EditableInfoContainerGrid = styled.div<{
	$gridColumns: EditableInfoContainerGridColumns;
	$gridTemplateColumns?: string;
	$padding?: FlexProps['p'];
	$alignItems?: FlexProps['align'];
}>`
	display: grid;
	gap: 0.5rem;
	position: relative;
	width: 100%;
	padding: ${({ $padding }) => $padding || '1rem'};
	grid-template-columns: ${({ $gridTemplateColumns, $gridColumns }) =>
		$gridTemplateColumns || `repeat(${$gridColumns}, 1fr)`};
	align-items: ${({ $alignItems }) => $alignItems || 'unset'};

	@media (max-width: 768px) {
		grid-template-columns: repeat(${({ $gridColumns }) => $gridColumns - 1 || 1}, 1fr);
	}

	@media (max-width: 480px) {
		grid-template-columns: 1fr;
	}
`;
